// import validate from 'validate.js'

import validate from 'validate.js'
import { MERCH_ACTORS_TABLE } from '../hooks/useValidationAES'
import { validateAddSupplyChainActorItemsTab, validateArrayObjectProperty } from './validateFunctions'

const createInvoiceStructure = (invErr, idx,translate) => {
    return Object?.entries(invErr)?.reduce((prev, [invKey, inVal]) => {
        return { ...prev, [`invoice${idx + 1}_${invKey}`]: inVal[0] ? { msg: `${translate('INVOICE')} 00${idx + 1} :: ${inVal[0]}` } : "" }
    }, {})
}


const createLineItemMsgStructure = (lineItmErr, idx, idxLineItm,translate) => {
    return Object?.entries(lineItmErr)?.reduce((liPrev, [liKey, liVal]) => (
       liVal ?({
            ...liPrev,
            [`invoice${idx + 1}_lineItem${idxLineItm + 1}_${liKey}`]:
                liVal[0] ? { msg: `${translate('INVOICE')} 00${idx + 1} :: ${translate('LINEITEM')} 00${idxLineItm + 1} :: ${liVal[0]}` } : ""
        }) : ({...liPrev})
    ), {})
}

const createRepElemErrStructure = (repElemList, repElemName, repElemPattern, invIdx, idxLineItem,translate) => {
    return repElemList?.reduce((repElemErrs, repElem, idxRepElem) => {
        let repElemErr = validate(repElem, repElemPattern) || {}
        repElemErr = createRepElemMsgStructure(repElemErr, repElemName, invIdx, idxLineItem, idxRepElem,translate)
        return { ...repElemErrs, ...repElemErr }
    }, {}) 
}


const createRepElemMsgStructure = (repElemErr, repElemName, invIdx, idxLineItem, idxRepElem,translate) => {
    return Object?.entries(repElemErr)?.reduce((repPrev, [repKey, repVal]) => {
        return {
            ...repPrev,
            [`invoice${invIdx + 1}_lineItem${idxLineItem + 1}_${repElemName}${idxRepElem + 1}_${repKey}`]:
                repVal[0] ? {
                    msg: `${translate('INVOICE')} 00${invIdx + 1} :: ${translate('LINEITEM')} 00${idxLineItem + 1} :: ${translate(repElemName)} 00${idxRepElem + 1}:: ${repVal[0]}`
                } : ""
        }
    }, {})
}

export const validateInvoices = (invoiceList, invoicePatterns = { }, additionalParams={},translate) => {
    const { addSupplyChainActorListHeader } = additionalParams
    let errorList = invoiceList?.reduce((invErrs, invoice, invoiceIndex) => {
        let invErr = validate({deliveryTerms:invoice?.invoiceHeader?.deliveryTerms},invoicePatterns?.invoice?.deliveryTerms) || {}
        invErr = createInvoiceStructure(invErr, invoiceIndex,translate)
        const merchErrors = validateMerchandise(invoice?.merchandiseList, invoicePatterns, invoiceIndex, addSupplyChainActorListHeader,translate)
        return { ...invErrs, ...invErr, ...merchErrors }
    }, {}) || {}

    return errorList
}



function validateMerchandise(merchandiseList, invoicePatterns, invoiceIndex, addSupplyChainActorListHeader,translate) {
    return merchandiseList?.reduce((merchErrors, merchandise, merchIndex) => {
        let merchError = validate(merchandise,invoicePatterns?.lineItem)
         merchError = createLineItemMsgStructure(merchError,invoiceIndex,merchIndex,translate)

        const prevDocErrs = createRepElemErrStructure(merchandise?.previousDocumentsList, "PREVIOUS_DOCUMENT", invoicePatterns?.previousDocumentsList, invoiceIndex, merchIndex,translate)
        const suppDocErrs = createRepElemErrStructure(merchandise?.supportingDocumentsList,"SUPP_DOCS", invoicePatterns?.supportingDocumentsList, invoiceIndex, merchIndex,translate)
        const addDocErrs = createRepElemErrStructure(merchandise?.additionalDocumentsList, "ADDITIONAL_DOCUMENT", invoicePatterns?.additionalDocumentsList, invoiceIndex, merchIndex,translate)
        const pkgsErrs = createRepElemErrStructure(merchandise?.packagesList, "PACKAGE", invoicePatterns?.packagesList, invoiceIndex, merchIndex,translate)


        const merchPartyAddSuppChainActorErrors = validateMerchPartiesActors(
            merchandise?.merchandiseParties?.additionalSupplyChainActorsList,
            "additionalSupplyChainActorsList",
            "role",
            invoicePatterns,
            invoiceIndex,
            merchIndex,
            translate
        )
        const merchPartyAuthorizationErrors = validateMerchPartiesActors(
            merchandise?.merchandiseParties?.authorizationsList,
            "authorizationsList",
            "type",
            invoicePatterns,
            invoiceIndex,
            merchIndex,
            translate
        )
        // addSupplyChainActorListHeader
        const [errorKeys=[], addSupplyChainActorErrorsInContextOfHeader={} ] = validateAddSupplyChainActorItemsTab({
            addSupplyChainActorListHeader,
            addSupplyChainActorListItems:merchandise?.merchandiseParties?.additionalSupplyChainActorsList||[], 
            key:'role', 
            tabName:'additionalSupplyChainActorsList', 
            tabValue:'ADD SUPPLY CHAIN ACTOR', 
            invoiceIndex, 
            itemIndex:merchIndex
        })
        return { 
            ...merchErrors, 
            ...merchError, 
            ...prevDocErrs,
            ...suppDocErrs,
            ...addDocErrs,
            ...pkgsErrs,
            ...merchPartyAddSuppChainActorErrors, 
            ...merchPartyAuthorizationErrors,
            ...addSupplyChainActorErrorsInContextOfHeader
        }
    }, {})
}

function validateMerchPartiesActors(merchPartiesActors,tableName,key,invoicePatterns,invoiceIndex,merchIndex,translate) {
    const tabName = MERCH_ACTORS_TABLE[tableName]?.key, tabValue = MERCH_ACTORS_TABLE[tableName]?.value
    const isActorOfSameRoleOrType = merchPartiesActors?.length>1 ? validateArrayObjectProperty(merchPartiesActors, key, '_') : false
    
    const errorKey = `invoice${invoiceIndex + 1}_lineItem${merchIndex + 1}_${tabName}`
    const error = isActorOfSameRoleOrType ? {
        [errorKey]:{
        msg:`${translate('INVOICE')} 00${invoiceIndex + 1} :: ${translate('LINEITEM')} 00${merchIndex + 1} :: ${translate('PARTIES')} :: ${translate(tabValue)} :: ${translate('can_not_have_more_than_one')} ${translate(tabValue)} ::  ${translate('can_not_have_more_than_one')} ${translate(tabValue)} ${translate(key)} ${translate('of_same_value')}`
    }}:{}

    return error
}


export{
    createRepElemMsgStructure,
    createInvoiceStructure,
    createLineItemMsgStructure
}